import React, { useContext } from 'react';
import { ComponentContext } from '../../../contexts';
import { degreesToRadians, SEAT_CIRCLE_DIAMETER, SEAT_CIRCLE_RADIUS, SEAT_SPACING, SeatLabelsGenerator, } from '../../..';
export var RoundTableSeats = function (_a) {
    var ellipseDiameter = _a.ellipseDiameter, definition = _a.definition;
    var Seat = useContext(ComponentContext).Seat;
    var positions = getSeatPositions(definition, ellipseDiameter);
    var labelGenerator = SeatLabelsGenerator(definition);
    return (React.createElement(React.Fragment, null, positions.map(function (position, index) {
        return position ? (React.createElement(Seat, { key: Number(index), x: position.x, y: position.y, definition: definition }, labelGenerator.next().value.toString())) : null;
    })));
};
var getSeatPositions = function (definition, ellipseDiameter) {
    var capacity = definition.capacity, empty = definition.empty;
    var spacingBetweenSeats = 360 / (capacity + empty);
    var seatsInfo = [];
    // Populate (fill is not suitable for objects due to reference problems)
    for (var i = 0; i < empty + capacity; i++) {
        seatsInfo.push({ degrees: 0, empty: false });
    }
    // Mark empty seats
    for (var i = 0; i < empty; i++) {
        var emptyIndex = !(i % 2) ? i / 2 : seatsInfo.length - Math.ceil(i / 2);
        seatsInfo[emptyIndex].empty = true;
    }
    // Set degrees
    for (var i = 0; i < seatsInfo.length; i++) {
        var offsetForEmptySeatCentering = empty && !(empty % 2) ? -(spacingBetweenSeats / 2) : 0;
        // Inverting index for clock-wise drawing (by default it would be counter-clock-wise)
        var invertedIndex = (seatsInfo.length - i) % seatsInfo.length;
        seatsInfo[invertedIndex].degrees = (spacingBetweenSeats * i + offsetForEmptySeatCentering + 180) % 360;
    }
    // Calculate positions
    var positions = seatsInfo.map(function (_a) {
        var degrees = _a.degrees, noSeat = _a.empty;
        return noSeat ? null : getSeatPosition(degrees, ellipseDiameter);
    });
    return positions;
};
var getSeatPosition = function (degrees, ellipseDiameter) {
    var angle = degreesToRadians(degrees);
    var seatCenterCircleRadius = ellipseDiameter / 2 + SEAT_SPACING + SEAT_CIRCLE_RADIUS;
    var x = seatCenterCircleRadius * Math.sin(angle) + ellipseDiameter / 2 + SEAT_CIRCLE_DIAMETER;
    var y = seatCenterCircleRadius * Math.cos(angle) + ellipseDiameter / 2 + SEAT_CIRCLE_DIAMETER;
    return { x: x, y: y };
};
//# sourceMappingURL=round-table-seats.js.map